import { AxiosResponse } from 'axios';
import { useAlert, useAuth, useZone } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { commonShowAlert } from 'lib';
import { useQuery, UseQueryResult } from 'react-query';

const getPolicy = async (
    url: string,
    token: string
): Promise<AxiosResponse<any[], any>> => {
    const headers = getDefaultHeaders(token);
    return axiosInstance().get(url, withHeaders(headers));
};

export const useIsPolicySigned = (): UseQueryResult<
    AxiosResponse<any, any>,
    unknown
> => {
    const { getToken } = useAuth();
    const { getSelectedDataZone } = useZone();
    const { showAlert, hideAlert, showErrorDetails } = useAlert();
    const selectedEnv = getSelectedDataZone();

    return useQuery(
        'signed-policy',
        async () => getPolicy('/acceptableusesignature', getToken()),
        {
            enabled: !!selectedEnv,
            onError: (error: any) => {
                const errorMessage: string =
                    error?.data?.message ??
                    'Unable to retrieve signed use policy';
                commonShowAlert(
                    showAlert,
                    hideAlert,
                    'error',
                    errorMessage,
                    JSON.stringify(error?.data ?? ''),
                    showErrorDetails
                );
            },
        }
    );
};
